import { ThemeEvents } from '@theme/events';

class ProductSupportCopy extends HTMLElement {
  connectedCallback() {
    this.scope = this.closest('.shopify-section');
    this.scope?.addEventListener(ThemeEvents.variantUpdate, this.updateCopy);
  }

  disconnectedCallback() {
    this.scope?.removeEventListener(ThemeEvents.variantUpdate, this.updateCopy);
  }

  updateCopy = (event) => {
    if (event.target?.closest('.shopify-section') !== this.scope) return;
    if (String(event.detail?.data?.productId) !== this.dataset.productId) return;
    const source = [...(event.detail?.data?.html?.querySelectorAll('artesta-product-support-copy') || [])]
      .find(element => element.dataset.productId === this.dataset.productId);
    if (!source) return;
    this.replaceChildren(...[...source.childNodes].map(node => node.cloneNode(true)));
  };
}

if (!customElements.get('artesta-product-support-copy')) {
  customElements.define('artesta-product-support-copy', ProductSupportCopy);
}
